import { AccountModel, AccountRole, DEBIT, NhapXuat } from '@/types/schemas';

export interface PhieuXuatKhoTableTabConfig {
  key: string;
  name: string;
  status?: string;
  color?: string;
}

export const TABLE_PAGE_SIZE = 500;

export const PHIEU_XUAT_KHO_TABLE_TABS: PhieuXuatKhoTableTabConfig[] = [
  { key: 'all', name: 'Tất cả' },
  { key: 'draft', name: 'Lập chứng từ', status: '0', color: '#EAD1DC' },
  { key: 'pending', name: 'Chờ duyệt', status: '3', color: '#ef4444' },
  { key: 'exported', name: 'Xuất kho', status: '5', color: '#3D85C6' },
  { key: 'other', name: 'Khác', status: '99', color: '#000000' }
];

export const DEFAULT_MA_NX_CODE = '1561';
export const DEFAULT_MA_NX_UUID = '';

export const createDefaultAccountData = (
  uuid: string = DEFAULT_MA_NX_UUID,
  code: string = DEFAULT_MA_NX_CODE
): AccountModel => {
  const fallbackCode = code || DEFAULT_MA_NX_CODE;
  return {
    uuid: uuid || '',
    code: fallbackCode,
    name: fallbackCode,
    role: AccountRole.ASSET,
    balance_type: DEBIT,
    locked: false,
    active: true,
    created: '',
    updated: ''
  };
};

export const createDefaultExportData = (
  uuid: string = DEFAULT_MA_NX_UUID,
  code: string = DEFAULT_MA_NX_CODE
): Partial<NhapXuat> => ({
  uuid: uuid || '',
  ma_nx: code || DEFAULT_MA_NX_CODE,
  tk_data: uuid ? createDefaultAccountData(uuid, code) : undefined
});
